<!-- eslint-disable space-before-function-paren -->
<template>
  <div class="xy-container background">
    <Title>
      <template #back>
        <div class="goback" @click="$router.back()">
          <a-icon type="left" />返回
        </div>
      </template>
    </Title>
    <div ref="eaxmImg" class="list_content xy-scroll-col">
      <div class="table-header write">
        <div class="composite-box">
          <a-row type="flex" style="width: 100%">
            <a-col style="width: 100%">
              <div class="composite-list">
                <ul>
                  <li
                    v-for="(item, index) in tabList"
                    :key="index"
                    :class="{ active: isActive === index }"
                    @click="checkTab(index)"
                  >
                    <span>{{ item.name }}</span>
                  </li>
                </ul>
                <div v-if="!isActive" class="serch_box">
                  <a-select
                    v-model="classId"
                    style="width: 200px; margin-right: 16px"
                    :get-popup-container="triggerNode => triggerNode.parentNode"
                  >
                    <a-select-option
                      v-for="item in classList"
                      :key="item.ClassId"
                      :value="item.ClassId"
                    >
                      {{ item.ClassName }}
                    </a-select-option>
                  </a-select>
                  <a-select
                    v-model="seId"
                    style="width: 200px; margin-right: 16px"
                    :get-popup-container="triggerNode => triggerNode.parentNode"
                  >
                    <a-select-option
                      v-for="item in subjects"
                      :key="item.se_id"
                      :value="item.se_id"
                    >
                      {{ item.course_name }}
                    </a-select-option>
                  </a-select>

                  <a-dropdown placement="bottomCenter">
                    <span class="playBtn">
                      导出
                      <a-icon type="down" class="middle" />
                    </span>
                    <a-menu slot="overlay" class="more">
                      <a-menu-item @click="downtestImgs(1)">
                        导出试卷原图
                      </a-menu-item>
                      <a-divider v-if="tabList[0].data.value != ''" />
                      <a-menu-item
                        v-if="tabList[0].data.value != ''"
                        @click="downtestImgs(0)"
                      >
                        导出留痕试卷
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div>
              </div>
            </a-col>
            <!-- <a-col class="tab_right" /> -->
          </a-row>
        </div>
      </div>
      <div class="content write">
        <!-- {{ tableData }} -->
        <a-table
          v-if="tableData.length != 0"
          :columns="columns"
          :data-source="tableData"
          row-key="index"
          :pagination="{ ...pagination, showQuickJumper: true }"
          @change="changeTable"
        >
          <div
            slot="url"
            slot-scope="text, record"
            class="img-list"
            @click="examImgClick(record, 1)"
          >
            <ElImage :src="text" :preview-src-list="imageList" />
          </div>

          <div
            slot="composite_url"
            slot-scope="text, record"
            class="img-list"
            @click="examImgClick(record, 2)"
          >
            <div v-show="!text" class="loading">
              <span class="blue" @click.stop="loadImage">点击加载</span>
            </div>
            <ElImage
              v-show="text"
              :src="text"
              :preview-src-list="composite_urls"
            />
          </div>
        </a-table>
        <NotData v-if="tableData.length == 0 && status" />
      </div>
      <Backtop :data-ele="dataEle" />
    </div>
  </div>
</template>
<script>
  import axios, { getCookie, Toast, getStore, creatImge } from '@/utils'

  import ElImage from '@comp/image1'

  export default {
    name: 'ExamImg',
    components: {
      ElImage
    },
    data() {
      return {
        end: false, //合成是否结束
        imageList: [],
        composite_urls: [],
        dataEle: null, //回到顶部
        mode: 'top',
        isActive: 0,
        selectVal: 'classid',
        placeholderVal: '请输入试卷号',
        inpVal: '',
        tabList: [
          {
            name: '试卷',
            data: {
              type: 's',
              column: 'classid',
              value: ''
            }
          },
          {
            name: '问题试卷',
            data: {
              type: 'p',
              column: 'code',
              value: ''
            }
          }
        ],
        columns: [
          {
            title: '班级',
            dataIndex: 'classname'
            // width: 100
          },
          {
            title: '姓名',
            dataIndex: 'name'
            // width: 100
          },
          {
            title: '考号',
            dataIndex: 'code'
            // width: 150
            // align: 'center'
          },
          {
            title: '试卷号',
            dataIndex: 'paperid'
            // width: 150
            // align: 'center'
          },
          {
            title: '总分',
            // dataIndex: 'esstotalscore',
            customRender: row => {
              return row.esstotalscore == -1 ? '--' : row.esstotalscore
            }
            // width: 150
            // align: 'center'
          },
          {
            title: '客观题总分',
            // dataIndex: 'essobjectivescore',
            customRender: row => {
              // return (
              //   <div>
              //     {row.essobjectivescore == -1 ? '--' : row.essobjectivescore}
              //   </div>
              // )
              return row.essobjectivescore == -1 ? '--' : row.essobjectivescore
            }
            // width: 150
            // align: 'center'
          },
          {
            title: '主观题总分',
            // dataIndex: 'esssubjectivescore',
            customRender: row => {
              return row.esssubjectivescore == -1
                ? '--'
                : row.esssubjectivescore
            }
            // width: 150
            // align: 'center'
          },
          {
            title: '试卷原图',
            dataIndex: 'url',
            width: 200,
            // align: 'center',
            scopedSlots: { customRender: 'url' }
          },
          {
            title: '留痕试卷',
            dataIndex: 'composite_url',
            width: 200,
            // align: 'center',
            scopedSlots: { customRender: 'composite_url' }
          },
          {
            title: '页码',
            dataIndex: 'pageno',
            width: 90
            // align: 'center',
            // scopedSlots: { customRender: 'pageno' }
          },
          {
            title: '操作',
            dataIndex: 'edit',
            width: 130,
            // align: 'center',
            customRender: (text, row) => {
              if (row.url) {
                return (
                  <a-button
                    type="primary"
                    ghost
                    onClick={() => this.downLoad(row)}
                  >
                    下载图片
                  </a-button>
                )
              }
            }
          }
        ],
        tableData: [],
        pagination: {
          current: 1,
          pageSize: 9,
          total: 0,
          hideOnSinglePage: true
        },
        status: false,
        examItem: {},
        isNext: false, //下一页
        roateNum: 0,
        curIdx: 0,
        classList: [], //班级列表
        selectClassId: '',
        subjects: [],
        seId: '',
        classId: '',
        editable: false, //编辑页码
        sourceFrom: 0 //3 手阅
      }
    },
    computed: {
      class_se_id() {
        return `${this.classId}_${this.seId}`
      }
      // classList() {
      //   let subject = this.subjects.find(item => item.seId == this.seId) || {
      //     classList: []
      //   }
      //   return subject.classList || []
      // }
    },

    watch: {
      classList(val) {
        this.classId = val[0].ClassId
      },

      class_se_id() {
        if (!this.classId || !this.seId) return
        this.getMarkTemplete()
        this.loadData()
      },
      classId() {
        this.getSubject()
      }
    },
    created() {
      this.isTestUnion = this.$route.query.isTestUnion || 1
      this.sourceFrom = +this.$route.query.sourceFrom
      this.meId = +this.$route.query.meId
      if (this.sourceFrom == 3) {
        this.tabList = [
          {
            name: '试卷',
            data: {
              type: 's',
              column: 'classid',
              value: ''
            }
          }
        ]
      }
    },
    mounted() {
      this.dataEle = this.$refs.eaxmImg
      // 获取试卷图片
      this.getsubjectclasslist()
    },

    methods: {
      getsubjectclasslist() {
        // axios({
        //   url: 'getsubjectclasslist',
        //   loading: true,
        //   params: {
        //     meId: this.meId
        //   }
        // }).then(res => {
        //   this.subjects = res.data || []
        //   this.seId = this.subjects[0].seId || ''
        // })
        let params = {
          meId: this.meId
        }
        axios({
          url: 'geteduclasslist',
          params
        }).then(res => {
          if (res.status && res.data) {
            this.classList = [...res.data]
          } else {
            Toast.fail(res.msg)
          }
        })
      },
      getSubject() {
        let params = {
          meId: this.meId,
          class_id: this.classId
        }
        axios({
          url: 'getexamclasssubjects',
          params
        }).then(res => {
          if (res.status) {
            this.subjects = [...res.data]

            if (this.seId) {
              // 如果有相同的就不改变了
              let se = this.subjects.find(i => i.se_id == this.seId)
              if (se) return
            }
            this.seId = this.subjects[0]?.se_id
          } else {
            Toast.fail(res.msg)
          }
        })
      },
      check(record) {
        if (!record.pageno || +record.pageno < 0) {
          Toast.fail('页码非法!')
          return
        }
        let params = {}

        params = record

        this.$nextTick(() => {
          record.editable = false
          this.changeExam(params)
        })
        // this.$emit('change', this.value)
      },
      edit(record) {
        // this.editable = true
        this.$nextTick(() => {
          record.editable = true
        })
        // this.$forceUpdate()
      },

      downtestImgs(n) {
        let api = ''
        if (this.isTestUnion == 2) {
          api = '/api/testunion/csan/getexamscanpagezip'
        } else {
          api = '/api/v1/csan/getexamscanpagezip'
        }
        let url = `${process.env.VUE_APP_API_test}${api}?examid=${
          this.seId
        }&column=${this.tabList[this.isActive].data.column}&value=${
          this.tabList[this.isActive].data.value
        }&orgin=${n}&X-ZYLX-TOKEN=${getCookie('X-ZYLX-TOKEN')}`

        if (this.isTestUnion == 2) {
          url += `&schoolId=${getStore('userInfo').schoolId}`
        }

        window.open(url, '_blank')
      },
      //修改页码
      onChangePage(val, row) {
        console.log(row, val, '---ab----')
      },
      //试卷修改
      changeExam(params) {
        axios({
          host: 'testApi',
          url: 'updatepageno',
          type: 'post',
          loading: true,
          params
        }).then(res => {
          console.log(res, '---res---')
        })
      },
      //获取img切换page数据
      checkPageAndItemIdx() {
        const nextImgDom = document.getElementsByClassName(
          'el-image-viewer__next'
        )[0]
        const perImgDom = document.getElementsByClassName(
          'el-image-viewer__prev'
        )[0]

        if (!this.curIdx) {
          if (perImgDom) perImgDom.style.display = 'none'
        } else {
          if (perImgDom) perImgDom.style.display = ''
        }
        if (this.curIdx === this.tableData.length - 1) {
          if (nextImgDom) nextImgDom.style.display = 'none'
        } else {
          if (nextImgDom) nextImgDom.style.display = ''
        }
      },
      //试卷图片 num:2留痕
      examImgClick(item, num) {
        if (num == 2 && !this.end) {
          return Toast.fail('试卷正在加载，请稍候...')
        }
        this.examItem = item
        this.curIdx = this.tableData.findIndex(
          item => item.url === this.examItem.url
        )

        let clickCount = 0
        // const rateNum = item.url.match(/(?<=_)\d+(?=\.[a-z]+$)/)
        // let roateNum = +rateNum || 0 //当前角度
        this.roateNum = 0

        /**左旋转 */
        const leftDom = document.getElementsByClassName(
          'el-icon-refresh-left'
        )[0]
        const leftRoate = () => {
          clickCount++
          this.roateNum -= 90
          if (this.roateNum < 0) this.roateNum = 270
          if (clickCount > 1) {
            clickCount = 0
            return
          }
          setTimeout(() => {
            if (leftDom) leftDom.click()
            this.rateImg()
          })
        }

        if (leftDom) {
          leftDom.removeEventListener('click', leftRoate)
          leftDom.addEventListener('click', leftRoate)
        }

        /** 右旋转 */
        const rightDom = document.getElementsByClassName(
          'el-icon-refresh-right'
        )[0]
        const rightRoate = () => {
          clickCount++
          this.roateNum += 90
          if (this.roateNum >= 360) this.roateNum = 0
          if (clickCount > 1) {
            clickCount = 0
            return
          }
          setTimeout(() => {
            if (rightDom) rightDom.click()
            this.rateImg()
          })
        }

        if (rightDom) {
          rightDom.removeEventListener('click', rightRoate)
          rightDom.addEventListener('click', rightRoate)
        }

        /**
         * 切换试卷
         */
        const imgSwitch = direction => {
          //旋转过直接更新
          // if (this.roateNum) {
          // }
          this.roateNum = 0

          //下一个
          if (direction === 'next') {
            this.curIdx++
            //不是最后一页则翻页
            // if (!piData.lastPage && piData.lastItem) {
            //   console.log('---下一页---')
            //   this.isNext = true
            //   this.changeTable({
            //     current: ++this.pagination.current
            //   })
            // }
          } else {
            this.curIdx--
            //上一个
            // if (!piData.firstPage && piData.firstItem) {
            //   console.log('---上一页---')
            //   this.isNext = false
            //   this.changeTable({
            //     current: --this.pagination.current
            //   })
            // }
          }
          this.examItem = this.tableData[this.curIdx]
          //当前切换数据
          this.checkPageAndItemIdx()
        }
        const nextImgDom = document.getElementsByClassName(
          'el-image-viewer__next'
        )[0]
        if (nextImgDom) {
          nextImgDom.removeEventListener('click', () => imgSwitch('next'))
          nextImgDom.addEventListener('click', () => imgSwitch('next'))
        }

        //
        const perImgDom = document.getElementsByClassName(
          'el-image-viewer__prev'
        )[0]
        if (perImgDom) {
          perImgDom.removeEventListener('click', () => imgSwitch('per'))
          perImgDom.addEventListener('click', () => imgSwitch('per'))
        }

        this.checkPageAndItemIdx() //初始化检查img切换数据
      },
      examImgClick1(cuitem) {
        this.curIdx = this.tableData.findIndex(item => item.url === cuitem.url)
      },
      //获取原始图片
      getUrl(key) {
        return key.replace(/(_\d+)+(?=\.[a-z]+$)/g, '')
      },
      //旋转图片
      rateImg() {
        // let angle = this.roateNum
        let { url, paperid, pageno } = this.examItem
        return axios({
          host: 'testApi',
          url: this.isTestUnion == 1 ? 'imgRotate' : 'testunionImgRotate',
          loading: true,
          params: {
            seId: this.seId,
            url,
            angle: 180,
            paperid,
            pageno
          }
        }).then(res => {
          if (res.status) {
            let index = this.tableData.findIndex(item => item.url === url)
            this.tableData[index].url = res.data
            this.imageList[index] = res.data
            // 重新合成试卷
            this.resetSum(index, res.data)
          }
        })
      },
      async resetSum(index, url) {
        let data_score = this.creatMark(this.examItem)
        let obj = await creatImge(url, data_score)
        this.tableData[index].composite_url = obj.url
        this.composite_urls[index] = obj.url
      },
      downLoad(e) {
        let url
        let filename
        if (e.url) {
          url = e.url
          if (!url.match(/^https/)) {
            url = url.replace(/^http/g, 'https')
          }
          filename = `?attname=${e.classname}${e.seCourseName}${e.name}_试卷原图.jpg`
          window.open(url + filename)
        }
        if (e.composite_url) {
          url = e.composite_url
          filename = `${e.classname}${e.seCourseName}${e.name}_留痕试卷.jpg`
          let aLink = document.createElement('a')
          aLink.style.display = 'none'
          aLink.href = url
          aLink.download = filename

          document.body.appendChild(aLink)
          aLink.click()
          document.body.removeChild(aLink)
        }
      },
      //table分页
      changeTable(data) {
        this.pagination.current = data.current
        this.getExamImg({ pageIndex: data.current })
        this.$refs.eaxmImg.scrollTop = 0
      },
      //切换tab
      checkTab(index) {
        this.isActive = index
        this.getExamImg()
      },
      //切换select
      handleChange(value) {
        this.tabList[this.isActive].data.value = ''
        if (value == 'code') {
          this.placeholderVal = '请输入考号'
        } else if (value == 'paperid') {
          this.placeholderVal = '请输入试卷号'
        } else if (value == 'classid') {
          this.loadData()
        } else {
          this.placeholderVal = '请输入姓名'
        }
      },
      //搜索
      loadData() {
        this.tabList[this.isActive].data.column = this.selectVal
        this.tabList[this.isActive].data.value =
          this.selectVal == 'classid' ? this.classId : this.inpVal
        this.pagination.current = 1
        this.getExamImg()
      },
      getMarkTemplete() {
        let params = {}
        if (this.isTestUnion == 1) {
          params = {
            examid: this.seId,
            schoolid: getStore('userInfo').schoolId
          }
        } else {
          params = {
            examid: this.seId
          }
        }
        axios({
          host: 'testApi',
          url: this.isTestUnion == 1 ? 'markTemplete' : 'testunionMarkTemplete',
          loading: true,
          params
        }).then(res => {
          let markTemplete = {}
          res.data.map(item => {
            if (!markTemplete[item.pageno]) {
              markTemplete[item.pageno] = [item]
            } else {
              markTemplete[item.pageno].push(item)
            }
          })
          this.markTemplete = markTemplete
        })
      },
      creatMark(item) {
        let data_score = []
        //  第一页的数据要显示 总分
        if (item.pageno === 1) {
          data_score = [
            {
              top: 150,

              code: 'Tx',
              left: 80,
              fontSize: 50,
              text: `总分： ${item.esstotalscore} 分`
            },
            {
              top: 220,
              left: 80,
              fontSize: 40,
              code: 'Tx',
              text: `客观题: ${item.essobjectivescore} 分`
            },
            {
              top: 270,
              left: 80,
              fontSize: 40,
              code: 'Tx',
              text: `主观题: ${item.esssubjectivescore} 分`
            }
          ]
        }
        let area = this.markTemplete[item.pageno] || []

        let subjectivescoredetail = item.subjectivescoredetail || []
        // 选做题匹配逻辑修改
        subjectivescoredetail.forEach(item => {
          let arr = area.filter(ele =>
            this.sourceFrom == 3
              ? item.itemid == ele.itemid
              : item.itemid == ele.itemid && item.libId == ele.frameid
          )
          if (arr.length) {
            let obj = arr[0]
            data_score.push({
              top: obj.y,
              left: obj.x,
              code: 'Tx',
              fontSize: 40,
              text: `${item.score}分/${obj.fullscore}分`
            })
          }
        })

        if (item.esstotalscore === -1) {
          return [
            {
              top: 250,
              left: 80,
              code: 'Tx',
              fontSize: 40,
              text: '成绩未发布'
            }
          ]
        }
        return data_score
      },
      getExamImg(page = {}) {
        this.end = false
        let params = {
          examid: this.seId,
          sort: 'paperid,pageno',
          order: 'asc',
          pageIndex: 1,
          pageSize: this.pagination.pageSize,
          ...page,
          ...this.tabList[this.isActive].data
        }
        // //全部
        // if (!this.isActive) {
        //   params.column = this.selectVal
        //   params.value = this.selectVal !== 'classid' ? this.inpVal : ''
        // }
        // testunionGetExamImg
        axios({
          host: 'testApi',
          url: this.isTestUnion == 1 ? 'getExamImg' : 'testunionGetExamImg',
          loading: true,
          params
        }).then(res => {
          this.status = true
          let data = res.data || {}
          this.pagination.total = data.total
          this.tableData = data.rows.map((item, index) => {
            item.index = index
            item.composite_url = ''
            item.editable = false
            return item
          })
          this.imageList = this.tableData.map(item => item.url)
          this.checkPageAndItemIdx()
        })
      },
      async loadImage() {
        let urls = this.tableData
        // 考虑 图片 合成 占用浏览器的资源  一张一张合并  不并发
        for (let i = 0; i < urls.length; i++) {
          let item = urls[i]
          let data_score = this.creatMark(item)
          let { url } = await creatImge(item.url, data_score)
          item.composite_url = url
        }
        this.composite_urls = this.tableData.map(item => item.composite_url)
        this.end = true
      }
    }
  }
</script>
<style lang="less" scoped>
  .more.ant-dropdown-menu {
    padding: 8px 12px;
    .ant-dropdown-menu-item {
      padding: 5px 0;
    }
  }
  /deep/.ant-divider-horizontal {
    margin: 0;
  }
  .background {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #f6f7fa;
    .write {
      background: #fff;
    }
    .list_content {
      flex: auto;
      padding-right: 18px;
      scrollbar-gutter: stable;
      display: flex;
      flex-direction: column;

      .table-header {
        padding-right: 24px;
        border-bottom: 1px solid #eee;
        .composite-box {
          width: 100%;
          margin: 0 auto;
          height: auto;
          display: flex;
          justify-content: flex-start;
          .composite-list {
            width: auto;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // margin-left: 52px;
            li {
              float: left;
              width: 130px;
              height: 60px;
              // padding: 14px 20px;
              border-right: none;
              text-align: center;
              font-size: 14px;
              cursor: pointer;
              color: #888888;
              line-height: 60px;
              padding: 0 29px;
            }
            .active {
              color: #a78bfa;
              span {
                font-weight: 550;
              }
            }
            .playBtn {
              cursor: pointer;
              color: #fff;
              padding: 6px 20px;
              // vertical-align: top;
              // margin-right: 16px;
              background-color: #a78bfa;
              border-radius: 4px;
              .middle {
                vertical-align: middle;
              }
            }
          }
        }
      }
      .content {
        // min-height: calc(100% - 62px);
        flex: auto;
        border-radius: 2px;
        padding: 20px 20px 30px;
      }
      .not_data_box {
        background-color: #fff;
      }
    }
  }

  /deep/.img-list {
    width: 100px;
    height: 100px;
    overflow: hidden;
    // margin: 0 auto;
    img {
      width: 100%;
    }

    .loading {
      padding-top: 30px;
    }
    .blue {
      color: @primary-color;
      cursor: pointer;
    }
  }
  // /deep/.editable-cell {
  //   width: 90px;
  //   // margin: 0 auto;
  /deep/.editable-cell-input-wrapper {
    width: 90px;
    display: flex;
    align-items: center;
    .ant-input-number {
      margin-right: 12px;
      flex: 1;
    }
  }
  // }

  ol,
  ul,
  dl {
    margin-bottom: 0;
  }
  /deep/.ant-table-pagination.ant-pagination {
    float: none;
    text-align: center;
    margin: 30px 0;
  }
</style>
